import React, { useState } from 'react';
import { useEffect } from 'react';

import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import FloatingButton from '../../../../components/FloatingButton';
import { NumberFormatCustom } from '../../../../components/NumberFormartCustom/NumberFormatCustom.component';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import useForm from '../../../../helpers/useForm';
import { incidentsInsuranceCompanies } from '../../../../services/incidents/incidents.service';
import NumberValidators from './OtherVehicleForm.validations';

const OtherVehicleDamage = () => {
  const { nextStep, sinister_body, updateSinisterBody } =
    useSinisterDataContext();
  const [hasOtherVehicleData, setHasOtherVehicleData] = useState(
    sinister_body.crash.third_party_data?.has_information || true
  );
  const [insurance, setInsurance] = useState(
    sinister_body.crash.third_party_data?.insurance || ''
  );
  const [defaultValues] = useState({
    fullname: sinister_body?.crash.third_party_data?.fullname || '',
    contact_phone: sinister_body?.crash.third_party_data?.contact_phone || '',
    identification_number:
      sinister_body?.crash.third_party_data?.identification_number || '',
    email: sinister_body?.crash.third_party_data?.email || '',
    model: sinister_body?.crash.third_party_data?.model || '',
    brand: sinister_body?.crash.third_party_data?.brand || '',
    license_plate: sinister_body?.crash.third_party_data?.license_plate || '',
    year: sinister_body?.crash.third_party_data?.year || '',
    // insurance: sinister_body?.crash.third_party_data?.insurance || "",
    policy_number: sinister_body?.crash.third_party_data?.policy_number || '',
    description: sinister_body?.crash.third_party_data?.description || '',
  });
  const [insuranceCompanies, setInsuranceCompanies] = useState([]);

  const callNextStep = () => {
    updateSinisterBody({
      crash: {
        ...sinister_body.crash,
        third_party_data: !hasOtherVehicleData
          ? { has_information: false }
          : { has_information: true, insurance: insurance, ...values },
      },
    });
    nextStep();
  };

  const { values, handleChange, errors } = useForm(
    callNextStep,
    NumberValidators,
    defaultValues
  );

  const handleChangeCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHasOtherVehicleData((event.target as HTMLInputElement).value === 'true');
  };

  useEffect(() => {
    incidentsInsuranceCompanies().then((response) => {
      setInsuranceCompanies(response.data);
    });
  }, []);

  const handleChangeAutocomplete = (event: any, value: any, reason: string) => {
    setInsurance(value);
  };

  return (
    <form>
      <Grid container>
        <Grid item xs={12}>
          <Box my={3}>
            <Typography variant="h6" color="textPrimary">
              Daños a otro vehículo
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={9}>
          <Box mr={2} my={2}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="has"
                value={hasOtherVehicleData}
                onChange={handleChangeCheck}
              >
                <FormControlLabel
                  value={false}
                  control={<Radio style={{ color: '#FA6400' }} />}
                  label="No tengo ningún dato del tercero"
                />
                <FormControlLabel
                  value={true}
                  control={<Radio style={{ color: '#FA6400' }} />}
                  label="Sí, tengo"
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
        {hasOtherVehicleData && (
          <>
            <Grid container>
              <Grid item xs={12}>
                <Box mr={2} my={2}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="h6" color="textPrimary">
                          ¿Quién conducía?
                        </Typography>
                      </Box>
                      <Box mt={2}>
                        <Typography variant="body1">
                          Completá con los datos que tengas
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">
                          Nombre y apellido
                        </Typography>
                        <TextField
                          value={values.fullname}
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          name="fullname"
                          id="fullname"
                          placeholder="Ingresá Nombre y apellido"
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">DNI</Typography>
                        <TextField
                          InputProps={{
                            inputComponent: NumberFormatCustom as any,
                          }}
                          value={values.identification_number}
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          error={!!errors['identification_number']}
                          helperText={errors['identification_number']}
                          name="identification_number"
                          id="identification_number"
                          placeholder="Ingresá tu número de documento"
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">Teléfono</Typography>
                        <TextField
                          InputProps={{
                            inputComponent: NumberFormatCustom as any,
                          }}
                          value={values.contact_phone}
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          error={!!errors['contact_phone']}
                          helperText={errors['contact_phone']}
                          id="contact_phone"
                          name="contact_phone"
                          placeholder="Teléfono"
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">Email</Typography>
                        <TextField
                          value={values.email}
                          type="email"
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          name="email"
                          id="email"
                          placeholder="Ingresá tu email"
                          variant="outlined"
                          error={!!errors['email']}
                          helperText={errors['email']}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box mr={2} my={2}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="h6" color="textPrimary">
                          Vehículo del tercero
                        </Typography>
                      </Box>
                      <Box mt={2}>
                        <Typography variant="body1">
                          Completá con los datos que tengas
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">Modelo</Typography>
                        <TextField
                          value={values.model}
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          name="model"
                          id="model"
                          placeholder="Ingresá el modelo del auto"
                          variant="outlined"
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">Marca</Typography>
                        <TextField
                          value={values.brand}
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          name="brand"
                          id="brand"
                          placeholder="Ingresá la marca del auto"
                          variant="outlined"
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">Patente</Typography>
                        <TextField
                          value={values.license_plate}
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          name="license_plate"
                          id="license_plate"
                          placeholder="Ingresá tu número de documento"
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">Año</Typography>
                        <TextField
                          InputProps={{
                            inputComponent: NumberFormatCustom as any,
                          }}
                          value={values.year}
                          error={!!errors['year']}
                          helperText={errors['year']}
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          name="year"
                          id="year"
                          placeholder="Ingresá el año del auto"
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <FormControl fullWidth size="small" variant="outlined">
                          <Typography variant="subtitle2">
                            Seguro del tercero
                          </Typography>
                          <Autocomplete
                            options={insuranceCompanies}
                            getOptionLabel={(insurance: any) =>
                              insurance.description
                            }
                            id="insurance"
                            onChange={handleChangeAutocomplete}
                            clearOnEscape
                            disableClearable
                            value={insurance}
                            size="small"
                            fullWidth
                            noOptionsText={'Sin resultados'}
                            loadingText={'Cargando...'}
                            renderInput={(params: any) => (
                              <TextField
                                {...params}
                                placeholder="Seleccione una opción"
                                name="insurance"
                                id="insurance"
                                variant="outlined"
                                size="small"
                              />
                            )}
                          />
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">
                          Número de póliza
                        </Typography>
                        <TextField
                          InputProps={{
                            inputComponent: NumberFormatCustom as any,
                          }}
                          value={values.policy_number}
                          size="small"
                          onChange={handleChange}
                          fullWidth={true}
                          name="policy_number"
                          id="policy_number"
                          placeholder="Ingresá el año del auto"
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            Descripción de los daños *
          </Typography>
          <Box mr={2} my={2}>
            <TextField
              value={values.description}
              name="description"
              id="description"
              onChange={handleChange}
              error={!!errors['description']}
              helperText={errors['description']}
              multiline
              fullWidth={true}
              rows={10}
              placeholder="Describí los daños del tercero de la forma más detallada posible."
              variant="outlined"
            />
          </Box>
        </Grid>
        <Grid container justify="center">
          <Grid item xs={12} sm={6}>
            <FloatingButton
              onClick={callNextStep}
              disabled={
                !!Object.keys(errors).length ||
                !Object.values(values).reduce((acc, curr) => acc || !!curr)
              }
            >
              Continuar
            </FloatingButton>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default OtherVehicleDamage;
